import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const EMPTY_STATE_CONFIG = {
  todos: {
    icon: 'Files',
    iconClassName: 'text-primary',
    iconBgClassName: 'bg-primary/10',
    title: 'Nenhum documento encontrado',
    description:
      'Você ainda não criou nenhum documento. Elabore um documento, crie a partir de um modelo ou use um modelo personalizado.',
    buttonLabel: 'Criar a partir de Modelo',
    buttonIcon: 'FilePlus',
    navigateTo: '/contract-generator',
  },
  modelos: {
    icon: 'FileText',
    iconClassName: 'text-primary',
    iconBgClassName: 'bg-primary/10',
    title: 'Nenhum documento encontrado',
    description:
      'Você ainda não gerou nenhum documento a partir de modelos padrão do sistema. Comece criando seu primeiro documento de forma rápida e profissional.',
    buttonLabel: 'Gerar Primeiro Documento',
    buttonIcon: 'Plus',
    navigateTo: '/contract-generator',
  },
  manuais: {
    icon: 'PenLine',
    iconClassName: 'text-violet-600 dark:text-violet-400',
    iconBgClassName: 'bg-violet-500/15',
    title: 'Nenhum documento manual encontrado',
    description:
      'Você ainda não criou nenhum documento manual. Escreva ou importe um documento para vê-lo aqui.',
    buttonLabel: 'Elaborar Documento',
    buttonIcon: 'PenLine',
    navigateTo: '/write-contract',
  },
  templates: {
    icon: 'LayoutTemplate',
    iconClassName: 'text-muted-foreground',
    iconBgClassName: 'bg-muted/40',
    title: 'Nenhum documento de modelo personalizado encontrado',
    description:
      'Você ainda não gerou nenhum documento a partir de um modelo personalizado. Escolha "Modelo personalizado" ao criar um documento.',
    buttonLabel: 'Criar a partir de Modelo',
    buttonIcon: 'LayoutTemplate',
    navigateTo: '/contract-generator',
  },
  uploads: {
    icon: 'Upload',
    iconClassName: 'text-primary',
    iconBgClassName: 'bg-primary/10',
    title: 'Nenhum documento enviado por upload',
    description:
      'Envie PDFs prontos para posicionar campos de assinatura e acompanhar o status aqui ou na página de upload.',
    buttonLabel: 'Enviar PDFs',
    buttonIcon: 'Upload',
    navigateTo: '/uploaded-documents',
  },
};

const EmptyState = ({ listTab = 'todos', hasActiveFilters = false }) => {
  const navigate = useNavigate();
  const config = EMPTY_STATE_CONFIG[listTab] ?? EMPTY_STATE_CONFIG.todos;

  if (hasActiveFilters) {
    return (
      <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center shadow-elevation-sm">
        <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-muted/40 rounded-full mx-auto mb-4 md:mb-6">
          <Icon name="Search" size={32} className="text-muted-foreground" />
        </div>
        <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2 md:mb-3">
          Nenhum documento encontrado
        </h3>
        <p className="text-sm md:text-base text-muted-foreground font-body max-w-md mx-auto">
          Nenhum documento corresponde aos filtros aplicados. Tente ajustar a busca ou limpar os filtros.
        </p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-8 md:p-12 text-center shadow-elevation-sm">
      <div
        className={`flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full mx-auto mb-4 md:mb-6 ${config.iconBgClassName}`}
      >
        <Icon name={config.icon} size={32} className={config.iconClassName} />
      </div>
      <h3 className="text-xl md:text-2xl font-semibold text-foreground font-heading mb-2 md:mb-3">
        {config.title}
      </h3>
      <p className="text-sm md:text-base text-muted-foreground font-body mb-6 md:mb-8 max-w-md mx-auto">
        {config.description}
      </p>
      <Button
        variant="default"
        size="lg"
        iconName={config.buttonIcon}
        iconPosition="left"
        onClick={() => navigate(config.navigateTo)}
      >
        {config.buttonLabel}
      </Button>
    </div>
  );
};

export default EmptyState;
